<template>
	<payHeader :bgStatus="bgStatus"></payHeader>
	<div class="user-repwd">
		<div class="container">
			<div class="head">
				<h1>找回密码</h1>
				<ul>
					<li class="step1 active">验证账号</li>
					<li class="step2 active">选择找回方式</li>
					<li class="step3 active">填写验证码</li>
					<li class="step4">重设密码</li>
				</ul>
			</div>
			<el-form>
				<el-form-item>
					<span class="label">手机号码</span>
					<el-input v-model="repwdDatas.mobile_encrypt" disabled />
				</el-form-item>
				<el-form-item class="code">
					<span class="label">验证码</span>
					<el-input v-model="code" placeholder="验证码" autocomplete="off" />
					<el-button type="primary" :disabled="codeSend" @click="codeChange">{{codeSendText}}</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" class="submit" @click="submitForm">下一步：重置密码</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
	<el-dialog align-center :close-on-click-modal="false" v-model="captchaVisible" title="请输入图片中的验证码" width="280">
		<el-image :src="captchaImg" @click="captchaReload" fit="contain" alt="验证码" title="点击刷新" style="margin-bottom: 10px;cursor: pointer;" />
	    <el-form class="captcha-form">
	      <el-form-item label="验证码">
	        <el-input v-model="captchaAnswer" autocomplete="off" />
	      </el-form-item>
	    </el-form>
	    <template #footer>
	      <div class="dialog-footer">
	        <el-button type="primary" @click="sendCodeClick">发送验证码</el-button>
	      </div>
	    </template>
	</el-dialog>
	<payFooter></payFooter>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { captchaFetch,sendSmscode,checkMobilecode } from '@/api/home';
	import { payHeader,payFooter } from 'landui-ui';
	import { ElMessage,ElMessageBox } from 'element-plus';
	
	const router = useRouter();
	const bgStatus = ref(true);
	const code = ref('');
	const codeSendText = ref('获取验证码');
	const codeSend = ref(false);
	const codeTime = ref(60);
	const captchaVisible = ref(false);
	const captchaAnswer = ref('');
	const captchaImg = ref('');
	const captchaId = ref('');
	const repwdDatas = ref({});
	
	const captchaChange = () => {
		captchaFetch().then((res) => {
			if (res.code == 200) {
				captchaImg.value = res.data.captcha_data;
				captchaId.value = res.data.captcha_id;
			}
		})
	}
	const codeChange = () => {
		captchaChange()
		captchaVisible.value = !captchaVisible.value;
	}
	const sendCodeClick = () => {
		const param = {
			'captcha_answer':captchaAnswer.value,
			'captcha_id':captchaId.value,
			'account': repwdDatas.value.account
		}
		sendSmscode(param).then((res) => {
			if (res.code === 200) {
				codeSend.value = true;
				codeSendText.value = codeTime.value+'s后重新发送';
				let timer = setInterval(() => {
				   codeTime.value--;
				   codeSendText.value = codeTime.value + 's后重新发送';
				   if (codeTime.value < 0) {
					   clearInterval(timer);
					   codeSendText.value = '获取验证码';
					   codeTime.value = 60;
					   codeSend.value = false
				   }
				}, 1000)
				captchaVisible.value = !captchaVisible.value;
			}else if(res.code === 205){
				ElMessageBox.confirm(
				    '您在当前页面停留时间过长，请返回第一步',
				    '温馨提示',
				    {
				      confirmButtonText: '立即登录',
				      showCancelButton: false,
				      closeOnClickModal: false,
				      showClose:false,
				      type: 'success',
				    }
				)
				.then(() => {
					router.push({ path: '/repwd' })
				})
			}else{
				captchaChange()
				captchaAnswer.value = ''
			}
		})
	}
	const submitForm = () => {
		const param = {'code':code.value,'account':repwdDatas.value.account};
		checkMobilecode(param).then((res) => {
			if(res.code === 200){
				router.push({ path: '/repwdReset' })
			}
			if(res.code === 205){
				ElMessageBox.confirm(
				    '您在当前页面停留时间过长，请返回第一步',
				    '温馨提示',
				    {
				      confirmButtonText: '立即登录',
				      showCancelButton: false,
				      closeOnClickModal: false,
				      showClose:false,
				      type: 'success',
				    }
				)
				.then(() => {
					router.push({ path: '/repwd' })
				})
				.catch(() => {
					
				})
			}
		})
	};
	const captchaReload = () => {
		captchaChange()
	}
	
	onMounted(() => {
		repwdDatas.value = JSON.parse(localStorage.getItem('repwdData'));
	})
	
</script>

<style lang="scss" scoped>
	.code{
		.el-button{position: absolute;left: 265px;top: 7px;width: 110px; text-align: center;}
	}
</style>
